import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
    useElementContext,
    useProductType,
} from "@ten24/slatwall-storefront-react-private/global";
import { ListingBanner } from "../ListingBanner/ListingBanner";
import { ProductTypeList } from "../ProductTypeList/ProductTypeList";
import { useContentContext } from "../../contexts/ContentContext";

const ProductTypeSearchListing = (props) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const {
        productTypeRequest,
        productTypeData,
        productTypeListRequest,
        crumbCalculator,
        productTypeRoute,
        isError,
        errorMessage,
    } = useProductType();
    const pageData = useContentContext();
    const { SearchListingStack } = useElementContext();

    return (
        <>
            {productTypeRequest.isLoaded && (
                <Helmet
                    title={productTypeRequest.data?.settings?.productHTMLTitleString}
                />
            )}
            <ListingBanner
                showCrumbs={false}
                crumbs={crumbCalculator()}
                heading={pageData?.title || productTypeData?.productTypeName}
                images={[pageData.pageLogo || productTypeData?.imageFile]}
                description={pageData?.description || productTypeData?.productTypeDescription}
                type="productType"
            />

            {isError && (
                <div className="container bg-light box-shadow-lg rounded-lg p-5">
                    <div className="row">
                        <div className="alert alert-info" role="alert">
                            {errorMessage}
                        </div>
                    </div>
                </div>
            )}

            <ProductTypeList
                isFetching={productTypeListRequest.isFetching || !productTypeRequest.isLoaded}
                onSelect={(urlTitle) => {
                    navigate(`/${productTypeRoute}/${urlTitle}`);
                }}
                data={productTypeData}
            />
            {productTypeData?.childProductTypes?.length === 0 && (
                <SearchListingStack
                    hide="productType"
                    initPreFilter={{
                        productType_slug: id,
                    }}
                    {...props}
                />
            )}
        </>
    );
};

export { ProductTypeSearchListing };
